import { fetch } from '../utils/fetch'
import {
  ENDPOINT_DYNAMIC_LINKS,
  ENDPOINT_DYNAMIC_LINK,
  ENDPOINT_NEW_DYNAMIC_LINK
} from '../constants'

const DYNAMIC_LINKS_REQUEST = 'blayzr/dynlinks/REQUEST'
const DYNAMIC_LINKS_SUCCESS = 'blayzr/dynlinks/SUCCESS'
const DYNAMIC_LINKS_FAILURE = 'blayzr/dynlinks/FAIL'

const SAVE_DYNAMIC_LINK_REQUEST = 'blayzr/dynlinks/SAVE_REQUEST'
export const SAVE_DYNAMIC_LINK_SUCCESS = 'blayzr/dynlinks/SAVE_SUCCESS'
const SAVE_DYNAMIC_LINK_FAILURE = 'blayzr/dynlinks/SAVE_FAIL'

const DELETE_DYNAMIC_LINK = 'blayzr/dynlinks/DELETE'

const initialState = {
  data: null,
  fetching: false,
  error: null,
  submitting: false,
  submitError: null
}

export default function reducer (state = initialState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case DYNAMIC_LINKS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case DYNAMIC_LINKS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: payload
      }
    case DYNAMIC_LINKS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error
      }
    case SAVE_DYNAMIC_LINK_REQUEST:
      return {
        ...state,
        submitting: true,
        submitError: false
      }
    case SAVE_DYNAMIC_LINK_SUCCESS:
      return {
        ...state,
        submitting: false,
        data: state.data.map(link => {
          return link.id === meta.id ? { ...link, ...payload } : link
        }).concat(meta.id ? [] : payload)
      }
    case SAVE_DYNAMIC_LINK_FAILURE:
      return {
        ...state,
        submitting: false,
        submitError: payload
      }
    case DELETE_DYNAMIC_LINK:
      if (state.data) {
        return {
          ...state,
          data: state.data.filter(link => link.id !== meta.id)
        }
      }
      return state
    default:
      return state
  }
}

export function dynamicLinksRequest () {
  return {
    type: DYNAMIC_LINKS_REQUEST
  }
}

export function dynamicLinksSuccess (data) {
  return {
    type: DYNAMIC_LINKS_SUCCESS,
    payload: data
  }
}

export function dynamicLinksFailure (error) {
  return {
    type: DYNAMIC_LINKS_FAILURE,
    payload: { error }
  }
}

export function saveDynamicLinkRequest (data, id) {
  return {
    type: SAVE_DYNAMIC_LINK_REQUEST,
    payload: data,
    meta: { id }
  }
}

export function saveDynamicLinkSuccess (data, id) {
  return {
    type: SAVE_DYNAMIC_LINK_SUCCESS,
    payload: data,
    meta: { id }
  }
}

export function saveDynamicLinkFailure (error) {
  return {
    type: SAVE_DYNAMIC_LINK_FAILURE,
    payload: error
  }
}

export function fetchDynamicLinks () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token
    }
    dispatch(dynamicLinksRequest())
    return fetch(ENDPOINT_DYNAMIC_LINKS, options, dispatch).then(data => {
      dispatch(dynamicLinksSuccess(data.records))
      return data.records
    }, e => {
      dispatch(dynamicLinksFailure(e))
    })
  }
}

export function saveDynamicLink (data, id) {
  return (dispatch, getState) => {
    const endpoint = id ? ENDPOINT_DYNAMIC_LINK.replace(':id', id) : ENDPOINT_NEW_DYNAMIC_LINK
    const options = {
      method: 'post',
      token: getState().auth.token,
      body: data
    }
    dispatch(saveDynamicLinkRequest(data, id))
    return fetch(endpoint, options, dispatch).then(data => {
      dispatch(saveDynamicLinkSuccess(data.records, id))
    }, e => {
      dispatch(saveDynamicLinkFailure(e))
    })
  }
}

export function deleteDynamicLink (id) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_DYNAMIC_LINK.replace(':id', id)
    fetch(endpoint, {
      method: 'delete',
      token: getState().auth.token
    })
    dispatch({
      type: DELETE_DYNAMIC_LINK,
      meta: { id }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/dynlinks.js